import { Ja } from './ja'
import { En } from './en'

export const isJapanese = navigator.language === 'ja'
export const Lang: typeof Ja = isJapanese ? Ja : En
export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
